import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./LoginPage.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, register } = useAuth();
  const [activeTab, setActiveTab] = useState("login");
  const formatCellphone = (value = "") => {
    const digits = value.replace(/\D/g, "").slice(0, 11);

    if (digits.length <= 2) {
      return digits ? `(${digits}` : "";
    }

    if (digits.length <= 7) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    }

    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const [form, setForm] = useState({ email: "", password: "" });
  const [registerForm, setRegisterForm] = useState({
    email: "",
    cellphone: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [registerError, setRegisterError] = useState("");
  const [loading, setLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/dashboard");
    } catch (err) {
      setError("Credenciais invalidas. Verifique seu e-mail e senha.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterChange = (event) => {
    const { name, value } = event.target;

    setRegisterForm((prev) => ({
      ...prev,
      [name]: name === "cellphone" ? formatCellphone(value) : value,
    }));
  };

  const handleRegisterSubmit = async (event) => {
    event.preventDefault();
    setRegisterError("");

    if (registerForm.password.length < 5) {
      setRegisterError("A senha deve ter no minimo 5 caracteres.");
      return;
    }

    if (registerForm.password !== registerForm.confirmPassword) {
      setRegisterError("As senhas nao coincidem.");
      return;
    }

    setRegisterLoading(true);
    try {
      await register(registerForm.email, registerForm.password);
      navigate("/dashboard");
    } catch (err) {
      setRegisterError("Nao foi possivel criar sua conta. Tente novamente.");
    } finally {
      setRegisterLoading(false);
    }
  };

  const switchTab = (tab) => {
    setActiveTab(tab);
    setError("");
    setRegisterError("");
  };

  return (
    <main className="auth-redesign">
      <div className="auth-redesign__bg-orb auth-redesign__bg-orb--one" />
      <div className="auth-redesign__bg-orb auth-redesign__bg-orb--two" />

      <div className="auth-redesign__layout">
        <section className="auth-story">
          <img
            src="/assets/favicon.png"
            alt="Logo"
            className="w-16 -mb-2 -mt-3"
          />
          <h1>Conecte anunciantes rurais e compradores reais</h1>
          <p>
            Publique produtos do campo, receba contatos de interessados e
            acompanhe oportunidades de venda em um só lugar.
          </p>

          <div className="auth-story__metrics">
            <article className="metric-card">
              <strong>+3.200</strong>
              <span>anúncios rurais ativos</span>
            </article>
            <article className="metric-card">
              <strong>12 estados</strong>
              <span>compradores buscando fornecedores locais</span>
            </article>
            <article className="metric-card">
              <strong>Contato</strong>
              <span>negociação simples entre anunciante e comprador</span>
            </article>
          </div>
        </section>

        <section className="auth-card-v2 fade-in">
          <div className="auth-card-v2__header">
            <h2>
              {activeTab === "login" ? "Acesse sua conta" : "Crie sua conta"}
            </h2>
            <p>
              {activeTab === "login"
                ? "Acesse sua conta para publicar produtos e atender compradores."
                : "Cadastre seu anunciante para publicar produtos e receber contatos."}
            </p>
          </div>

          <div
            className="auth-card-v2__tabs"
            role="tablist"
            aria-label="Acesso e cadastro"
          >
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "login"}
              className={`auth-tab ${activeTab === "login" ? "auth-tab--active" : ""}`}
              onClick={() => switchTab("login")}
            >
              Acessar
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "register"}
              className={`auth-tab ${activeTab === "register" ? "auth-tab--active" : ""}`}
              onClick={() => switchTab("register")}
            >
              Criar conta
            </button>
          </div>

          {activeTab === "login" ? (
            <form onSubmit={handleSubmit} className="auth-card-v2__form">
              <div className="field">
                <label className="label">E-mail corporativo</label>
                <input
                  className="input"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="voce@seunegocio.com.br"
                  required
                />
              </div>

              <div className="field">
                <label className="label">Senha</label>
                <input
                  className="input"
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Sua senha"
                  required
                />
              </div>

              <p className="auth-card-v2__back-link" style={{ textAlign: "right" }}>
                <Link to="/esqueci-senha">Esqueceu sua senha?</Link>
              </p>

              {error ? <div className="alert">{error}</div> : null}

              <button
                className="button button--primary !shadow-sm"
                type="submit"
                disabled={loading}
              >
                {loading ? "Entrando..." : "Entrar"}
              </button>
            </form>
          ) : (
            <form
              onSubmit={handleRegisterSubmit}
              className="auth-card-v2__form"
            >
              <div className="field">
                <label className="label">Celular</label>
                <input
                  className="input"
                  name="cellphone"
                  type="tel"
                  value={registerForm.cellphone}
                  onChange={handleRegisterChange}
                  placeholder="(00) 00000-0000"
                  inputMode="numeric"
                  required
                />
              </div>

              <div className="field">
                <label className="label">E-mail corporativo</label>
                <input
                  className="input"
                  name="email"
                  type="email"
                  value={registerForm.email}
                  onChange={handleRegisterChange}
                  placeholder="voce@suanegocio.com.br"
                  required
                />
              </div>

              <div className="field">
                <label className="label">Senha</label>
                <input
                  className="input"
                  name="password"
                  type="password"
                  value={registerForm.password}
                  onChange={handleRegisterChange}
                  placeholder="Crie uma senha"
                  minLength={5}
                  required
                />
              </div>

              <div className="field">
                <label className="label">Confirmar senha</label>
                <input
                  className="input"
                  name="confirmPassword"
                  type="password"
                  value={registerForm.confirmPassword}
                  onChange={handleRegisterChange}
                  placeholder="Repita a senha"
                  required
                />
              </div>

              {registerError ? (
                <div className="alert">{registerError}</div>
              ) : null}

              <button
                className="button button--primary !shadow-sm"
                type="submit"
                disabled={registerLoading}
              >
                {registerLoading ? "Criando conta..." : "Criar conta"}
              </button>
            </form>
          )}
        </section>
      </div>
    </main>
  );
};

export default LoginPage;
